const PAYMENT = {
  TYPES: {
    ACH: 'ACH',
    CC: 'CC',
    EFT: 'EFT',
    DD: 'DD',
  },
};

Object.freeze(PAYMENT);

export default PAYMENT;
